module.exports = __webpack_public_path__ + "img/plein.97f4583.svg";